/*
 * @Description: 琛ュ彂璁㈠崟
 * @Author: gao shuai
 * @Date: 2020-05-15 18:07:30
 * @LastEditTime: 2020-05-20 18:15:40
 * @LastEditors: gao shuai
 */

import api from '../services/api';
export default {
  // 鍒嗙粍涓嬫媺
  async gameTeam() {
  return api({ url: '/api/SelectDropDown/GetGroupNameNameListAsync', method: 'get' });
  },
  // 琛ュ彂鍒楄〃
  async reorderList(params) {
  return api({ url: '/api/ReissueRecords/GetReissueRecordsListAsync', method: 'get', params });
  },
  // 娓告垙鍒嗗尯涓嬫媺鍒楄〃
  async gamelist(params) {
  return api({ url: '/api/SelectDropDown/GetPartitionNameListAsync', method: 'get', params });
  },
  // 娓呯悊琛ュ彂璁板綍
  async clearOrder(params) {
  return api({ url: '/api/ReissueRecords/ClearReisuueRecordAsync', method: 'post', data: params });
  },
  /* --------------------------2.璁㈠崟琛ュ彂-------------------------- */
  // 鍏呭€兼柟寮忎笅鎷?
  async payDrow(params) {
  return api({ url: '/api/SelectDropDown/GetPayModeNameListAsync', method: 'get', params });
  },
  // 璁㈠崟琛ュ彂琛ュ崟璁板綍
  async orderList1(params) {
  return api({ url: '/api/OrderReissueRecords/GetOrderReissueRecordsTaskListAsync', method: 'get', params });
  },
  // 璁㈠崟琛ュ彂涓殑瀹氭椂浠诲姟
  async orderList2(params) {
  return api({ url: '/api/OrderReissueRecords/GetOrderSchedulerJobsListAsync', method: 'get', params });
  },
  // 鍒犻櫎瀹氭椂浠诲姟
  async delTask(params) {
  return api({ url: '/api/OrderReissueRecords/DeleteSchedulerJobAsync', method: 'post', data: params });
  },
  // 鎵嬪姩琛ュ崟
  async handOrder(params) {
  return api({ url: '/api/ReissueRecords/ManualReissueAsync', method: 'post', data: params });
  },
  // 鏁村尯琛ュ崟
  async allOrder(params) {
  return api({ url: '/api/ReissueRecords/AllReissueAsync', method: 'post', data: params });
  }
};
